/* KURO — the size guide dialog
 *
 * The one script this theme adds. A <dialog> would have given most of this
 * for free, but it paints a backdrop and a border from the UA sheet and both
 * would have to be undone, so the behaviour is written out instead: escape,
 * the click outside, the scroll lock, the focus trap, and the return of focus
 * to the link that opened it.
 *
 * Delegated from the document, so a section re-rendered by the theme editor
 * needs no re-binding.
 */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  var openDialog = null;
  var opener = null;
  var scrollY = 0;

  function focusable(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function open(dialog, trigger) {
    if (openDialog) return;
    openDialog = dialog;
    opener = trigger || null;

    dialog.hidden = false;

    /* Hold the page still without letting it jump to the top: the body is
       pinned at the offset it was already at and put back on close. */
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = '-' + scrollY + 'px';
    document.body.classList.add('kuro-y-sg-locked');

    var first = focusable(dialog)[0];
    if (first) first.focus();
  }

  function close() {
    if (!openDialog) return;
    var dialog = openDialog;
    openDialog = null;

    dialog.hidden = true;

    document.body.classList.remove('kuro-y-sg-locked');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);

    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-kuro-sg-open]');
    if (trigger) {
      var dialog = document.getElementById(trigger.getAttribute('data-kuro-sg-open'));
      if (dialog) {
        e.preventDefault();
        open(dialog, trigger);
      }
      return;
    }
    if (e.target.closest('[data-kuro-sg-close]') || e.target.closest('[data-kuro-sg-veil]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openDialog) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close();
      return;
    }

    if (e.key !== 'Tab') return;

    /* The trap. Tab off either end and it comes back round rather than
       walking into the page behind, which is still there and still readable
       to the browser even though it cannot be seen past the veil. */
    var items = focusable(openDialog);
    if (!items.length) {
      e.preventDefault();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;

    if (e.shiftKey && (active === first || !openDialog.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
